export interface AnalyticsCardTooltipProps {
  value: number;
  label: string;
}

/**
 * The content shown inside `AnalyticsCard.Chart`'s hover tooltip -- just `value`/`label`, no
 * knowledge of recharts' own `active`/`payload` render-prop contract. See `AnalyticsCardChart`,
 * which adapts recharts' `Tooltip` `content` callback into these two plain props.
 */
export const AnalyticsCardTooltip = ({ value, label }: AnalyticsCardTooltipProps) => (
  <div className="rounded-[calc(var(--radius)-4px)] border border-border bg-card px-2.5 py-1.5 text-xs shadow-md">
    <div className="font-semibold tabular-nums text-card-foreground">{value}</div>
    <div className="text-muted-foreground">{label}</div>
  </div>
);
